import React, { useState } from 'react';
import './Services.css';

const Services = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeService, setActiveService] = useState(null);

  const services = [

     {
      id: 'hausmeisterservice',
      title: 'HAUSMEISTERSERVICE',
      link: '#contact',
      hasPopup: true,
      backgroundImage: `${process.env.PUBLIC_URL}/hameservice.jpeg`
    },
    
    {
      id: 'gartenpflege',
      title: 'GARTENPFLEGE',
      link: '#contact',
      hasPopup: true,
      backgroundImage: `${process.env.PUBLIC_URL}/garten.jpeg`
    },
    {
      id: 'fensterreinigung',
      title: 'GEBÄUDEREINIGUNG',
      link: '#contact',
      hasPopup: true,
      backgroundImage: `${process.env.PUBLIC_URL}/gebau1.jpeg`
    },
    {
      id: 'winterdienst',
      title: 'FENSTERREINIGUNG',
      link: '#contact',
      hasPopup: true,
      backgroundImage: `${process.env.PUBLIC_URL}/fensterr.jpeg`
    },
  
    {
      id: 'heckenschnitt',
      title: 'WINTERDIENST',
      link: '#contact',
      hasPopup: true,
      backgroundImage: `${process.env.PUBLIC_URL}/winter.jpeg`
    },
    {
      id: 'entruempelungen',
      title: 'ENTRÜMPELUNGEN',

      link: '#contact',
      hasPopup: true,
      backgroundImage: `${process.env.PUBLIC_URL}/entrum.jpeg`
    },
   
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openModal = (serviceId) => {
    setActiveService(serviceId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <section id="services" className="services section">
      <div className="container">
        <p className="section-subtitle"><em>Sauber. Pünktlich. Professionell.- Wir kümmern uns um Ihre Immobilie.</em></p>
        <h2 className="section-title">Unsere Leistungen- und noch vieles mehr</h2>
        <div className="services-grid">
          {services.map((service) => (
            <div 
              key={service.id} 
              className="service-card no-overlay" 
              id={service.id}
              style={service.backgroundImage ? {
                backgroundImage: `url(${service.backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative'
              } : {}}
            >
              {service.backgroundImage && <div className="service-card-overlay"></div>}
              <div className="service-content-centered">
                <div className="service-icon">
                  <i className={service.icon}></i>
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                {service.hasPopup ? (
                  <button className="service-link btn btn-secondary" onClick={() => openModal(service.id)}>
                    Mehr Erfahren
                  </button>
                ) : (
                  <a href={service.link} className="service-link btn btn-secondary">
                    Mehr Erfahren
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal Popup */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div 
            className="modal-content" 
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundImage: `url(${
                activeService === 'gartenpflege' 
                  ? process.env.PUBLIC_URL + '/garten.jpeg' 
                  : activeService === 'fensterreinigung'
                  ? process.env.PUBLIC_URL + '/gebau1.jpeg'
                  : activeService === 'winterdienst'
                  ? process.env.PUBLIC_URL + '/fensterr.jpeg'
                  : activeService === 'heckenschnitt'
                  ? process.env.PUBLIC_URL + '/winter.jpeg'
                  : activeService === 'entruempelungen'
                  ? process.env.PUBLIC_URL + '/entrum.jpeg'
                  : process.env.PUBLIC_URL + '/hameservice.jpeg'
              })`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              filter: 'brightness(0.7)'
            }}
          >
            <button className="modal-close" onClick={closeModal}>
              <i className="fas fa-times"></i>
            </button>
            <h2 className="modal-title">
              {activeService === 'gartenpflege' ? 'Gartenpflege' : activeService === 'fensterreinigung' ? 'Gebäudereinigung' : activeService === 'winterdienst' ? 'Fensterreinigung' : activeService === 'heckenschnitt' ? 'Winterdienst' : activeService === 'entruempelungen' ? 'Entrümpelungen' : 'Hausmeisterservice'}
            </h2>
            <div className="modal-body">
              {activeService === 'gartenpflege' ? (
                <>
                  <p className="modal-intro">
                    Ein gepflegter Garten trägt zu einem angemessenen Wohngefühl bei und hinterlässt einen positiven Eindruck bei Besuchern, Nachbarn und Kunden.
                    Damit Ihre Grünflächen jederzeit ordentlich und sauber aussehen, übernehmen wir die regelmäßige Pflege Ihres Gartens.
                  </p>
                  <ul className="modal-list">
                    <li>Anlegen von Rasenflächen</li>
                    <li>Bepflanzen nach Wunsch</li>
                    <li>Entsorgung von Schnittgut</li>
                    <li>Hecken- und Formschnitt</li>
                    <li>Unkrautbekämpfung</li>
                    <li>Laubbeseitigung</li>
                    <li>Grünanlagen pflegen</li>
                  </ul>
                </>
              ) : activeService === 'fensterreinigung' ? (
                <>
                  <p className="modal-intro">
                    Möchten Sie, dass Ihr Eigentum immer gepflegt und in bestem Zustand bleibt?
                    Nicht nur die Außenbereiche, auch Innenräume wie Treppen, Eingänge und Gemeinschaftsräume verdienen regelmäßige Pflege.
                    Unser Team sorgt dafür, dass alles sauber, sicher und ansprechend bleibt – damit sich Bewohner und Besucher rundum wohlfühlen.
                  </p>
                  <div className="modal-subtitle">UNSERE LEISTUNGEN IM BEREICH INNENREINIGUNG:</div>
                  <ul className="modal-list">
                    <li>Die Treppen kehren und wischen</li>
                    <li>Treppengeländer reinigen</li>
                    <li>Fensterreinigung für klare Sicht und gepflegtes Ambiente</li>
                    <li>Hauseingangstüren sauber halten</li>
                    <li>Reinigung der Kellerzugänge und Kellerräume</li>
                    <li>Säuberung von Briefkasten- und Klingelanlagen</li>
                    <li>Spinnweben Entfernen</li>
                    <li>Aufzug reinigen</li>
                    <li>Fußmattenreinigung</li>
                  </ul>
                </>
              ) : activeService === 'winterdienst' ? (
                <>
                  <p className="modal-intro">
                    Fensterreinigung – klarer Durchblick für Ihr Zuhause oder Ihr Unternehmen
                    Saubere Fenster lassen Räume heller wirken und hinterlassen einen gepflegten Eindruck – egal ob Zuhause, in Wohnanlagen oder in Firmengebäuden.
                    Unser Team sorgt dafür, dass Ihre Fenster streifenfrei, sauber und glänzend bleiben. Mit professionellem Equipment und sorgfältiger Arbeit übernehmen wir die Reinigung Ihrer Fenster innen und außen – zuverlässig, sicher und termingerecht.
                    Verlassen Sie sich auf uns für ein rundum gepflegtes Erscheinungsbild Ihrer Immobilie.
                  </p>
                </>
              ) : activeService === 'heckenschnitt' ? (
                <>
                  <p className="modal-intro">
                    ZUVERLÄSSIGER WINTERDIENST FÜR SICHERE GEBÄUDE UND WEGE
                    
                    Mit moderner Ausrüstung sorgen wir dafür, dass Ihre Gehwege, Einfahrten und Zugänge bei Eis und Schnee sicher und frei von Gefahren bleiben.
                  </p>
                  <div className="modal-subtitle">UNSERE LEISTUNGEN IM WINTERDIENST:</div>
                  <ul className="modal-list">
                    <li>Schneeräumung von Gehwegen, Höfen, Parkplätze, Hauseingängen und Garageneinfahrten</li>
                    <li>24/7 Einsatzbereitschaft bei Schnee- und Eisglätte</li>
                    <li>Befreiung von Eis und Schnee für sichere Wege</li>
                    <li>Bereitstellung von Streugut für Ihr Objekt</li>
                    <li>Entfernung des Streuguts im Frühjahr</li>
                  </ul>
                  <p className="modal-intro">
                    Mit unserem professionellen Winterdienst sorgen Sie für Sicherheit, Komfort und Werterhalt Ihrer Immobilie – unabhängig von Schnee oder Eis.
                  </p>
                </>
              ) : activeService === 'entruempelungen' ? (
                <>
                  <p className="modal-intro">
                    Professionelle Entrümpelung von Wohnungen, Häusern und Gewerbeimmobilien. Schnell, zuverlässig und umweltfreundlich.
                    Wir kümmern um die Entrümpelung und Reinigung Ihrer Immobilie, sodass Sie sich um andere wichtige Dinge kümmern können.
                  </p>
                </>
              ) : (
                <>
                  <p className="modal-intro">
                    Wir übernehmen alle Hausmeisterarbeiten in Lindau und Umgebung und sorgen dafür, dass Ihre Immobilie gepflegt und funktionsfähig bleibt.
                  </p>
                  <ul className="modal-list">
                    <li>Regelmäßige Objektkontrolle für Sicherheit und Werthalt</li>
                    <li>Ablesen von Zählern (Strom, Wasser, Gas)</li>
                    <li>Mülltonnen bereitstellen</li>
                    <li>Kontrolle und Reinigung der Wasserschächte</li>
                  </ul>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Services;
